<template>
  <div>
    <Modal v-model="showModal" :title="title" width="1000">
      <div v-for="(logs, logsIdx) in data" :key="logsIdx">
        <div style="font-size: 14px" class="jenkins-job-build-logs-content">
          <Alert show-icon v-if="!logs.items.length">无记录</Alert>
          <div v-for="(item, index) in logs.items" :key="index">
            <span>{{ index + 1 }}. </span>
            <span style="color: #999">{{ moment(item.timestamp).format('YYYY-MM-DD HH:mm:ss') }} </span>
            <span>{{ item.msg }} </span>
          </div>
          <br/>
          <div v-for="(item, index) in logs.items" :key="index">
            <Alert>
              <p>Revision {{ item.revision }} by <a v-if="item.author" target="_blank" :href="item.author.absoluteUrl">{{ item.author.fullName }}</a>：</p>
              <p>{{ item.msg }}</p>
            </Alert>
            <table style="width: 100%; text-align: left">
              <tr>
                <th style="min-width: 100px">Change Type</th>
                <th>Path in Repository</th>
                <th>Path in Workspace</th>
              </tr>
              <tr v-for="(pathItem, pathIndex) in item.paths" :key="pathIndex">
                <td><Icon :type="pathItem.editType === 'add' ? 'md-add'
              : pathItem.editType === 'delete' ? 'md-close'
              : pathItem.editType === 'edit' ? 'md-create' : ''"></Icon></td>
                <td style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{ pathItem.file }}</td>
                <td>{{ item.affectedPaths[pathIndex] }}</td>
              </tr>
            </table>
            <br/>
          </div>
        </div>
        <Divider v-if="data.length > 1"/>
      </div>
      <div slot="footer">
        <Button @click="showModal = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'console-output',
  data () {
    return {
      title: '提交记录',
      showModal: false,
      data: [],
      moment: moment
    }
  },
  methods: {
    openModal (logs) {
      console.log(logs)
      this.data = logs
      this.showModal = true
    }
  }
}
</script>

<style scoped>
  .jenkins-job-build-logs-content {
    padding: 0;
    overflow-y: auto;
    max-height: 600px;
    padding-bottom: 5px;
    padding-right: 5px;
  }
  .jenkins-job-build-logs-content::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  .jenkins-job-build-logs-content::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .jenkins-job-build-logs-content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
